import React from 'react';
import styled from 'styled-components';
import { Link, H2 } from '../../../../@nitty';
import { Container } from '../../../styles';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex: 1;
`

const Column = styled.div`
    width: 100%;

    ${({ theme }) => theme.layoutBreakpoints.medium} {
        width: 50%;
    }

     ${({ theme }) => theme.layoutBreakpoints.large} {
        width: 25%;
    }
`

const Cell = styled.div`
    min-height: 3rem;
`

const SytledContainer = styled(Container)`
    flex-direction: column;
`

const Header = styled(H2)`
    margin-bottom: 1rem;
`

const View = ({ links, currentSection }) => {
    return (
        <SytledContainer>
            <Header>Popular {currentSection} searches</Header>
            <Wrapper>
                {links.map((link, index) => (
                    <Column key={index}>
                        <Cell>
                            <Link variant="secondary" href={link.href}>{link.text}</Link>
                        </Cell>
                    </Column>
                ))}
            </Wrapper>
        </SytledContainer>
    );
};

export default View;
